import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a24d56d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bookmark-setting" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_table_pager = _resolveComponent("table-pager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode("表格"),
    _createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          label: _ctx.$t('account.serial'),
          width: "54"
        }, null, 8 /* PROPS */, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "bookmarkId",
          label: _ctx.$t('bookmarkManage.id'),
          width: "72"
        }, null, 8 /* PROPS */, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "mangaName",
          label: _ctx.$t('mangaManage.name'),
          width: "160"
        }, null, 8 /* PROPS */, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "chapterName",
          label: _ctx.$t('chapterManage.name'),
          width: "320"
        }, null, 8 /* PROPS */, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "page",
          label: _ctx.$t('bookmarkManage.page'),
          width: "60"
        }, null, 8 /* PROPS */, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "添加日期",
          width: "170"
        }),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('option.option')
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              size: "small",
              type: "danger",
              icon: _ctx.Delete,
              onClick: ($event: any) => (_ctx.handleDelete(scope.$index, scope.row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('option.delete')), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["icon", "onClick"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["data"]),
    _createCommentVNode("分页"),
    _createVNode(_component_table_pager, {
      ref: "pager",
      onPageChange: _ctx.load_table,
      count: _ctx.count
    }, null, 8 /* PROPS */, ["onPageChange", "count"])
  ]))
}